<script setup lang="ts">
import { computed, shallowRef, watch } from "vue";
import { locale } from "../../../locale";
import { fullScreenModeState } from "../../../states/fullScreenMode";
import { getShareNotThisUserTrack } from "../../../states/screenShareState";

const videoEl = shallowRef<HTMLVideoElement | null>(null);
const screenTrack = computed(() => {
  return getShareNotThisUserTrack()
}) 
watch(
  () => videoEl.value && screenTrack.value,
  (next, prev) => {
    if (next && !prev) {
      screenTrack.value?.attach(videoEl.value as HTMLVideoElement);
    }
  },
  { immediate: true },
);
</script>
<template>
  <div class="video-area" :class="{ fullScreen: fullScreenModeState }" :style="{
    backgroundColor: fullScreenModeState ? '#000' : 'transparent'
  }">
    <video v-if="screenTrack" ref="videoEl" autoplay :controls="false" />
    <div v-else class="preloader">
      <span class="loader"></span>
      <span class="text">{{ locale.loadingDemonstrate }}</span>
    </div>
  </div>
</template>
<style scoped>
video {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  width: 100%;
  border-radius: 8px;
}

.video-area {
  height: 100%;
  width: 100%;
  padding: 12px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.video-area.fullScreen {
  border-radius: 0;
  padding: 0;

  video {
    border-radius: 0;
  }
}

.text {
  color: #fff;
  font-size: 16px;
  text-align: center;
}

.preloader {
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
